import { render, staticRenderFns } from "./AutomaticReports.vue?vue&type=template&id=44eae450&"
import script from "./AutomaticReports.vue?vue&type=script&lang=ts&"
export * from "./AutomaticReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports